<template>
  <div class="i18n-lang-bar">
    <div class="bar-left">
      <span class="bar-label">显示语言</span>
      <el-select
        :value="value"
        size="small"
        style="width: 160px"
        :disabled="disabled"
        @change="onSelect">
        <el-option
          v-for="opt in localeOptions"
          :key="opt.value"
          :label="opt.label"
          :value="opt.value">
          <span>{{ opt.label }}</span>
          <span v-if="opt.value === sourceLang" style="color:#909399;margin-left:6px;">(原文)</span>
        </el-option>
      </el-select>
      <span class="bar-hint" v-if="value === sourceLang">当前编辑主表原文</span>
      <span class="bar-hint" v-else>当前编辑该语言译文</span>
    </div>
    <div class="bar-right" v-if="showTranslate && entityId">
      <el-button size="mini" type="primary" :loading="translating" @click="autoTranslate">
        从原文自动翻译其它语言
      </el-button>
    </div>
  </div>
</template>

<script>
const LABELS = {
  en: 'English（英语）',
  zh: '中文（简体）',
  tw: '中文（繁體）',
  ar: 'العربية（阿拉伯语）',
  es: 'Español（西班牙语）',
  ru: 'Русский（俄语）',
  nl: 'Nederlands（荷兰语）',
  pl: 'Polski（波兰语）',
  it: 'Italiano（意大利语）',
  fr: 'Français（法语）',
  de: 'Deutsch（德语）',
  pt: 'Português（葡萄牙语）',
  ja: '日本語（日语）',
  ko: '한국어（韩语）',
  hi: 'हिन्दी（印地语）',
  tr: 'Türkçe（土耳其语）',
  id: 'Bahasa Indonesia（印尼语）',
  ur: 'اردو（乌尔都语）',
  vi: 'Tiếng Việt（越南语）',
  th: 'ไทย（泰语）'
}

const ALL_LOCALES = ['en', 'zh', 'tw', 'ar', 'es', 'ru', 'nl', 'pl', 'it', 'fr', 'de', 'pt', 'ja', 'ko', 'hi', 'tr', 'id', 'ur', 'vi', 'th']

export default {
  name: 'I18nLangBar',
  props: {
    value: { type: String, default: 'en' },
    entityType: { type: String, default: '' },
    entityId: { type: String, default: '' },
    sourceLang: { type: String, default: 'en' },
    locales: {
      type: Array,
      default: () => ALL_LOCALES
    },
    showTranslate: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { translating: false }
  },
  computed: {
    localeOptions() {
      return (this.locales || []).map(v => ({
        value: v,
        label: LABELS[v] || v
      }))
    }
  },
  methods: {
    onSelect(lang) {
      this.$emit('input', lang)
      this.$emit('change', lang)
    },
    async autoTranslate() {
      if (!this.entityId) {
        this.$message.warning('请先保存原文再翻译')
        return
      }
      this.translating = true
      try {
        const res = await this.$api.post('/service/i18n/translate', {
          entity_type: this.entityType,
          entity_id: this.entityId
        })
        if (this.$apiSuccess(res)) {
          const d = res.data || {}
          this.$message.success(`翻译完成：更新 ${d.updated || 0}，跳过 ${d.skipped || 0}`)
          this.$emit('translated', d)
        } else {
          this.$message.error(res.message || '翻译失败')
        }
      } finally {
        this.translating = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.i18n-lang-bar
  display flex
  align-items center
  justify-content space-between
  flex-wrap wrap
  gap 12px
  margin-bottom 16px
  padding 10px 14px
  background #f5f7fa
  border 1px solid #e4e7ed
  border-radius 8px
.bar-left
  display flex
  align-items center
  gap 10px
  flex-wrap wrap
.bar-label
  font-size 13px
  color #606266
  font-weight 600
.bar-hint
  font-size 12px
  color #909399
</style>
